import { formatIsoDateToLocale } from "@pulse-ui/formatting";
import { IAGRoleManagementDataRow } from "@pulse-ui/types/components/AGTable";
import { IUser } from "@pulse-ui/types/components/RoleManagement";

export const parseUserToRow = (user: IUser): IAGRoleManagementDataRow => ({
  row_id: user.org_user_id,
  firstname: user.firstname,
  lastname: user.lastname,
  status: user.is_active,
  roles: user.roles,
  portfolios: user.portfolios,
  created: formatIsoDateToLocale(user.created),
  last_modified: formatIsoDateToLocale(user.last_modified),
  original_row: user,
});
